<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <form [formGroup]="pageForm" (ngSubmit)="submit()">
            <div class="mt-2 w-full">
                <label class="text-xs w-full mb-1" for="gradeId">Assign to Grade *</label>
                <select formControlName="gradeId" id="gradeId" name="gradeId" (change)="onGradeChange($event)"
                    class="rounded w-full my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                    @for (item of grades; track $index) {
                    <option [selected]="item.id === gradeId" [value]="item.id">{{item.gradeName}}</option>
                    }
                </select>
            </div>
            <div class="mt-2 w-full">
                <label class="text-xs w-full mb-1" for="publishBy">Visible On</label>
                <input type="datetime-local" name="publishBy" id="publishBy" formControlName="publishBy" [min]="minTime"
                    class="rounded w-full my-auto outline-none ring-0 focus:outline-none focus:ring-0">
            </div>
            <div class="flex flex-row gap-4 justify-end mt-4">
                <button type="button" (click)="onCancel()" class="btn-cancel">Cancel</button>
                <app-btn-submit [isDisabled]="pageForm.invalid || ((loading$ | async) ?? false)"
                    [isLoading]="((loading$ | async) ?? false)" [actionText]="action"
                    icon="fa fa-save"></app-btn-submit>
            </div>
        </form>
    </div>
</div>